import { Component, EventEmitter, Input, Output,ElementRef,ViewChild } from '@angular/core';
import { CommunicationService } from '../../communication.service';
import { FlightsFilterTypeApiKeyEnum } from 'src/app/pages/flights-page/src/app/data-access/model/enums/flight-filter.enum';
import { IFilterMetadata } from 'src/app/pages/flights-page/src/app/data-access/model/interfaces/flight-filter.interface';

@Component({
  selector: 'tic-hotel-filters',
  templateUrl: './hotel-filters.component.html',
  styleUrls: ['./hotel-filters.component.scss']
})
export class HotelFiltersComponent {
  @Input() filtersOptionsMetadata!: IFilterMetadata;
  @Input() expandAllFiltersAsDefault: boolean = true;
  @Output() onFilterSelected: any = new EventEmitter();
  @ViewChild('minvaluehtl') minvaluehtl!: ElementRef;
  @ViewChild('maxvaluehtl') maxvaluehtl!: ElementRef;
  @ViewChild('minpricehlt') minpricehlt!: ElementRef;
  @ViewChild('maxpricehlt') maxpricehlt!: ElementRef;
  @ViewChild('rangecontainer') rangecontainer!: ElementRef;
  flightsFilterTypeApiKeyEnum = FlightsFilterTypeApiKeyEnum;
  data: any;
  flightResults: any = [];
  isOpen = true;
  toggleflt = false;
  showsort = false;
  constructor(private communicationService: CommunicationService) {}

  ngAfterViewInit() {
    this.communicationService.sendElementReference(this.minvaluehtl.nativeElement,this.maxvaluehtl.nativeElement,this.rangecontainer.nativeElement);
  }

  toggleClass() {
    this.isOpen = !this.isOpen;
  }

  togglefltfunc() {
    this.toggleflt = !this.toggleflt;
  }

  togglesort() {
    this.showsort = !this.showsort;
  }

  toggleClassToNearestElement(event: Event) {
    const button = event.target as HTMLButtonElement;
    const closestContainer = button.closest(".accrd");
    // Check if the closest ancestor with class 'container' is found
    if (closestContainer) {
      closestContainer.classList.toggle("open");
    }
  }

  onSelectMinPrice($event: Event) {
    var minvalue = ($event.target as HTMLInputElement).value;
    var maxvalue = (
      this.maxpricehlt.nativeElement as HTMLInputElement
    ).value;

    this.onFilterSelected.emit({ minvalue, maxvalue });
  }

  onSelectMaxPrice($event: Event) {
    var minvalue = ($event.target as HTMLInputElement).value;
    var maxvalue = (
      this.minpricehlt.nativeElement as HTMLInputElement
    ).value;

    this.onFilterSelected.emit({ minvalue, maxvalue });
  }

  onSelectionChange(
    value: number,
    filterType: FlightsFilterTypeApiKeyEnum
  ): void {
    this.onFilterSelected.emit({ filterType, value });
  }
  
}
